// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mKJWg6W_CLHoiO {
  position: relative;
  flex-basis: min-content;
  flex-grow: 1;
  flex-shrink: 1;
  min-height: 20px;
  color: var(--accent-text-bolder, var(--ds-text, #172b4d));
}
.X38hkBeoL1ig8x {
  order: 1;
  min-height: 0;
}
.SbpCwp4lyCHGRw {
  margin: var(--ds-space-0, 0);
}
.KLvU2mDGTQrsWG {
  z-index: 0;
  width: 100%;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px) var(--ds-space-100, 8px) var(--ds-space-075, 6px) var(--ds-space-150, 12px);
  overflow: hidden;
  border: none;
  background-color: transparent;
  font-size: 14px;
  font-weight: var(--ds-font-weight-semibold, 600);
  line-height: 20px;
  text-align: left;
  white-space: normal;
  cursor: pointer;
  overflow-wrap: anywhere;
}
.bwoLvY94uSRdaI {
  cursor: auto;
}
.X38hkBeoL1ig8x .KLvU2mDGTQrsWG {
  padding: var(--ds-space-050, 4px);
  line-height: 1em;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.KLvU2mDGTQrsWG[hidden] {
  display: none;
}
.DYByIA2wV31gY2 {
  display: flex;
  padding: var(--ds-space-0, 0);
}
.erMrp1MUgNmz7e {
  font-size: 12px;
  font-style: italic;
}
.XmUgdJ5MepKUCB {
  position: absolute;
  z-index: -1;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  box-sizing: border-box;
  min-height: 20px;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px) var(--ds-space-100, 8px) var(--ds-space-075, 6px) var(--ds-space-150, 12px);
  overflow: hidden;
  border-radius: var(--ds-border-radius-200, 8px);
  opacity: 0;
  background: transparent;
  box-shadow: none;
  font-weight: var(--ds-font-weight-semibold, 600);
  resize: none;
  overflow-wrap: break-word;
}
.qjA2XgaT9DABQn {
  display: block;
  position: static;
  z-index: 0;
  box-sizing: border-box;
  width: 100%;
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px);
  overflow: hidden;
  border: none;
  border-radius: var(--ds-border-radius-100, 3px);
  outline: none;
  opacity: 1;
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
  /* Focus State */
}
.qjA2XgaT9DABQn:focus {
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `mKJWg6W_CLHoiO`,
	"container--collapsed": `X38hkBeoL1ig8x`,
	"heading": `SbpCwp4lyCHGRw`,
	"listName": `KLvU2mDGTQrsWG`,
	"listName--disabled": `bwoLvY94uSRdaI`,
	"ListNameText": `DYByIA2wV31gY2`,
	"listId": `erMrp1MUgNmz7e`,
	"listNameTextarea": `XmUgdJ5MepKUCB`,
	"listNameTextarea--editing": `qjA2XgaT9DABQn`
};
export default ___CSS_LOADER_EXPORT___;
